import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 爆料91专区导航",
    description: "你访问的页面不存在或已调整归属，可以返回爆料91首页，或从专区总览重新选择想看的合集内容。",
    keywords: "爆料91,页面未找到,专区导航",
    path: location.pathname,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "页面未找到",
      inLanguage: "zh-CN",
    },
  });

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mx-auto text-center">
          <p className="font-label text-[5rem] md:text-[7rem] leading-none text-background-300 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            这个页面不在合集里
          </h1>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            你访问的地址可能输错了，或者对应内容已经调整了归属。
            回到首页，或从专区总览重新挑一个方向继续浏览都可以。
          </p>
          <p className="mt-4 text-xs text-foreground-400 font-mono break-all">
            {location.pathname}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/zones"
              className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md border border-foreground-300 text-sm text-foreground-900 whitespace-nowrap cursor-pointer hover:border-foreground-900 transition-colors"
            >
              <i className="ri-layout-grid-fill"></i>
              专区总览
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}